import anticipationPhoto from '../assets/photography/muhammad-taha-ibrahim-african-men-car.jpg';
import roadPhoto from '../assets/photography/sweder-breet-kenya-road.jpg';
import arrivalPhoto from '../assets/photography/wendy-brooks-nyali-beach.jpg';
import routeScreen from '../assets/Screen/route.jpg';
import navigateScreen from '../assets/Screen/navigate.jpg';
import navigateLoop from '../assets/Screen/navigate-loop.mp4';
import arrivedScreen from '../assets/Screen/arrived.jpg';

export const MILESTONES = [
  {
    id: 'before-the-road',
    eyebrow: 'Before the road',
    heading: 'Plan the journey together.',
    body: 'Choose where you are going, pick a route and invite your group.',
    photo: {
      src: anticipationPhoto,
      width: 500,
      height: 750,
      objectPosition: '50% 40%',
      alt: 'Two travellers laughing in the front seats of a car before setting off.',
    },
    product: {
      src: routeScreen,
      width: 590,
      height: 1280,
      alt: 'Planning a Tulink trip: the fastest route is selected, with an option to add people before starting.',
    },
  },
  {
    id: 'while-you-move',
    eyebrow: 'While you move',
    heading: 'Stay together on the road.',
    body: 'Everyone follows the same route with turn-by-turn directions, and you can see who is moving.',
    photo: {
      src: roadPhoto,
      width: 1600,
      height: 1067,
      objectPosition: '50% 60%',
      alt: 'An open road running towards the horizon across the Kenyan plains.',
    },
    product: {
      src: navigateScreen,
      video: navigateLoop,
      width: 1170,
      height: 2532,
      alt: 'A Tulink journey in progress, with turn-by-turn directions and two members moving along the route.',
    },
  },
  {
    id: 'at-the-destination',
    eyebrow: 'At the destination',
    heading: 'Arrive together.',
    body: 'See who has arrived and who is still on the way.',
    photo: {
      src: arrivalPhoto,
      width: 1600,
      height: 355,
      objectPosition: '50% 50%',
      alt: 'People walking along Nyali Beach in Mombasa as the sun sets over the water.',
    },
    product: {
      src: arrivedScreen,
      width: 590,
      height: 1280,
      alt: 'Tulink confirming “You’ve arrived!” while it waits for the last member of the group.',
    },
  },
];
